import React, { FunctionComponent } from 'react';
import { Selector, SelectorOption } from './Selector';
import { faCat, faDog, faTurtle } from '@fortawesome/pro-light-svg-icons';
import { PetType, PetTypeIds } from '@spike/model';

export interface PetOptionData {
    id: number;
    name: string;
    ownerName: string;
    petType?: PetType;
    petId?: number;
}

interface PetSelectorProps {
    label?: string;
    placeholder?: string;
    pets: PetOptionData[];
    value?: number;
    disabled?: boolean;
    loading?: boolean;
    onSearch?: (query: string) => void;
    onChange: (pet?: PetOptionData) => void;
}

export const PetSelector: FunctionComponent<PetSelectorProps> = ({
    label = 'Pet',
    placeholder = 'Search pet',
    pets,
    value,
    disabled,
    loading = false,
    onSearch,
    onChange
}) => {
    const getIconForType = (petType?: PetType) => {
        switch (petType?.id) {
            case PetTypeIds.DOGS:
                return faDog;
            case PetTypeIds.CATS:
                return faCat;
            default:
                return faTurtle;
        }
    };

    const petOptions: SelectorOption<PetOptionData>[] = pets.map(pet => ({
        label: pet.name.split(' ')[0],
        subLabel: pet.ownerName,
        icon: getIconForType(pet.petType),
        value: pet.petId?.toString() ?? '',
        data: pet
    }));

    return (
        <Selector<PetOptionData>
            label={label}
            placeholder={placeholder}
            options={petOptions}
            value={value ? value.toString() : undefined}
            disabled={disabled}
            loading={loading}
            onSearch={onSearch}
            onChange={(_, option) => {
                onChange(option?.data);
            }}
        />
    );
};

export default PetSelector;
